<template>
  <div class="dashboardCampaignDetail">
    <template v-if="!isLoading && !loadingData">
      <div class="dashboardCampaignDetail__header">
        <div class="dashboardCampaignDetail__header__back">
          <button @click.stop="gotoAllCampaign" class="link"><span class="ic-left"><i class="icon-chevronleft"></i></span> All Campaign</button>
        </div>
        <div class="dashboardCampaignDetail__header__title">
          <h1 class="medium-title">{{detail.title}}</h1>
        </div>
        <div class="dashboardCampaignDetail__header__subtitle">
          <div class="subhead date">
            Period of Campaign <b>{{duedate(detail.start)}} - {{duedate(detail.end)}}</b>
          </div>
          <div class="subhead status">
            Status <span :class="getColor(detail.get_status)">{{detail.get_status | capitalizing}}</span>
          </div>
        </div>
        <div class="dashboardCampaignDetail__header__action">
          <a target="_blank" :href="content.url" v-for="(content, index) in contents" :key="index">
            <button class="btn-regular secondary">View Ad {{index + 1}}</button>
          </a>
        </div>
      </div>
      <div class="dashboardCampaignDetail__content">
        <adx-detail-list :items="items" />
      </div>
      <div>
        <adx-pagination 
          :selectedPage="selectedPage"
          :maxPage="maxPage"
          @change-page="selectPage"
        />
      </div>
    </template>
    <div v-else class="loading">
      <adx-loading />
    </div>
  </div>
</template>

<script>
import DetailList from '@/views/Dashboard/Host/Campaign/CampaignDetail/ListItems'
import Loading from '@/components/Loading/Primary'

import { APagination } from "ui-kit-v1"

import api from '@/api'
import { apiV2 } from '@/api/urls'
import moment from 'moment'

export default {
  name: 'adx-dashboard-campaign-detail',
  components: {
    'adx-detail-list': DetailList,
    'adx-loading': Loading,
    'adx-pagination': APagination
  },
  props: {

  },
  data() {
    return {
      items: [],
      detail: {
        title: '',
        start: null,
        end: null,
        get_status: '',
      },
      contents: null,
      isLoading: false,
      loadingData: false,
      selectedPage: 1,
      maxPage: 1
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.isLoading = true
    this.loadData()
    this.loadDataDetail()
    this.loadDataContent()
    this.isLoading = false
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    loadData() {
      (async () => {
        this.loadingData = true
        const id = this.$route.params.id
        let params = {page: this.selectedPage}
        const response = await api.get(apiV2.hostCampaignsDetailDevice(id), {
          params: params, needToken: true 
        })
        this.setQueryRouter()

        if (response.status == 200) {
          this.items = response.data.results
          this.maxPage = response.data.max_page
        } else {

        }
        this.loadingData = false
      })();
    },
    loadDataDetail() {
      (async () => {
        this.loadingData = true
        const id = this.$route.params.id
        const response = await api.get(apiV2.hostCampaignsDetail(id), { needToken: true })

        if (response.status == 200) {
          this.detail = response.data
        }else {

        }
        this.loadingData = false
      })();
    },
    loadDataContent() {
      (async () => {
        this.loadingData = true
        const id = this.$route.params.id
        const response = await api.get(apiV2.hostCampaignsDetailContent(id), { needToken: true })

        if (response.status == 200) {
          this.contents = response.data
        }else {

        }
        this.loadingData = false
      })();
    },
    duedate(time) {
      const utc = time
      return moment.utc(time).local().format('DD MMM YYYY');
    },
    gotoAllCampaign() {
      this.$router.push({name: 'hostcampaign'})
    },
    getColor(status) {
      if (status) {
        const statusLower = status.toLowerCase()
        if(statusLower === 'waiting for approval') {
          return 'color-orange'
        }
        if(statusLower === 'upcoming') {
          return 'color-teal'
        }
        if(statusLower === 'active') {
          return 'color-green'
        }
        if(statusLower === 'expired' || statusLower === 'canceled') {
          return 'color-grey'
        }
      }
    },
    selectPage(page) {
      this.selectedPage = page
      this.loadData()
    },
    setQueryRouter() {
      this.$router.replace({ query: {page: this.selectedPage} })
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
